import React from "react";

type SvgName = "wallet" | "calendar" | "creditCardInfo" | "search";

interface SvgIconProps extends React.SVGProps<SVGSVGElement> {
  name: SvgName;
  size?: number | string;
}

const icons: Record<SvgName, React.FC<React.SVGProps<SVGSVGElement>>> = {
  wallet: (props) => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.083 4.06667V2.16667C15.083 1.25 14.333 0.5 13.4163 0.5H1.74967C0.824674 0.5 0.0830078 1.25 0.0830078 2.16667V13.8333C0.0830078 14.75 0.824674 15.5 1.74967 15.5H13.4163C14.333 15.5 15.083 14.75 15.083 13.8333V11.9333C15.5747 11.6417 15.9163 11.1167 15.9163 10.5V5.5C15.9163 4.88333 15.5747 4.35833 15.083 4.06667ZM14.2497 5.5V10.5H8.41634V5.5H14.2497ZM1.74967 13.8333V2.16667H13.4163V3.83333H8.41634C7.49967 3.83333 6.74967 4.58333 6.74967 5.5V10.5C6.74967 11.4167 7.49967 12.1667 8.41634 12.1667H13.4163V13.8333H1.74967Z"
        fill={props.fill ?? "#00AB50"}
      />
      <path
        d="M10.9163 9.25C11.6067 9.25 12.1663 8.69036 12.1663 8C12.1663 7.30964 11.6067 6.75 10.9163 6.75C10.226 6.75 9.66634 7.30964 9.66634 8C9.66634 8.69036 10.226 9.25 10.9163 9.25Z"
        fill={props.fill ?? "#00AB50"}
      />
    </svg>
  ),
  calendar: (props) => (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.5 4.5H3.5V5.5H2.5V4.5ZM9.5 2V9C9.5 9.55 9.05 10 8.5 10H1.5C0.945 10 0.5 9.55 0.5 9L0.505 2C0.505 1.45 0.945 1 1.5 1H2V0H3V1H7V0H8V1H8.5C9.05 1 9.5 1.45 9.5 2ZM1.5 3H8.5V2H1.5V3ZM8.5 9V4H1.5V9H8.5ZM6.5 5.5H7.5V4.5H6.5V5.5ZM4.5 5.5H5.5V4.5H4.5V5.5Z"
        fill="#D65900"
      />
    </svg>
  ),
  creditCardInfo: (props) => (
    <svg
      width="19"
      height="15"
      viewBox="0 0 19 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.3913 0H1.37681C0.612681 0 0.00688405 0.612681 0.00688405 1.37681L0 9.63768C0 10.4018 0.612681 11.0145 1.37681 11.0145C1.37681 11.0145 11.6272 11.0145 12.3913 11.0145C13.1554 11.0145 13.7681 10.4018 13.7681 9.63768V1.37681C13.7681 0.612681 13.1554 0 12.3913 0ZM12.3913 9.63768H1.37681V5.50725H12.3913V9.63768ZM12.3913 2.75362H1.37681V1.37681H12.3913V2.75362Z"
        fill="#8122CA"
      />
      <path
        d="M15.1884 7.32944C13.2884 7.32944 11.7463 8.87147 11.7463 10.7715C11.7463 12.6715 13.2884 14.2135 15.1884 14.2135C17.0884 14.2135 18.6304 12.6715 18.6304 10.7715C18.6304 8.87147 17.0884 7.32944 15.1884 7.32944ZM15.5326 12.4925H14.8442V11.8041H15.5326V12.4925ZM15.5326 11.1157H14.8442V9.05046H15.5326V11.1157Z"
        fill="#8122CA"
      />
    </svg>
  ),
  search: (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M20.47 21.53a.75.75 0 1 0 1.06-1.06l-1.06 1.06Zm-9.97-4.28a6.75 6.75 0 0 1-6.75-6.75h-1.5a8.25 8.25 0 0 0 8.25 8.25v-1.5ZM3.75 10.5a6.75 6.75 0 0 1 6.75-6.75v-1.5a8.25 8.25 0 0 0-8.25 8.25h1.5Zm6.75-6.75a6.75 6.75 0 0 1 6.75 6.75h1.5a8.25 8.25 0 0 0-8.25-8.25v1.5Zm11.03 16.72-5.196-5.197-1.061 1.06 5.197 5.197 1.06-1.06Zm-4.28-9.97c0 1.864-.755 3.55-1.977 4.773l1.06 1.06A8.226 8.226 0 0 0 18.75 10.5h-1.5Zm-1.977 4.773A6.727 6.727 0 0 1 10.5 17.25v1.5a8.226 8.226 0 0 0 5.834-2.416l-1.061-1.061Z"></path>
    </svg>
  ),
};

const KaribuSvgIcon: React.FC<SvgIconProps> = ({
  name,
  size = 24,
  ...props
}) => {
  const IconComponent = icons[name];

  if (!IconComponent) {
    console.error(`SVG "${name}" not found!`);
    return null;
  }

  return <IconComponent width={size} height={size} {...props} />;
};

export default KaribuSvgIcon;
